import { Button } from "@mui/material";
import { VendorType } from "../types";
import { useAppSelector } from "../hooks";

interface Props {
  vendorType: VendorType;
}
function VendorTypeComponent(props: Props) {
  const { vendorType } = props;
  const { id, name } = vendorType;
  const isAdmin = useAppSelector((state) => state.app.isAdmin);
  const vendors = useAppSelector((state) => state.app.vendors);

  const handleClick = () => {
    window.location.href = `/vendors/${id}`;
  };

  return (
    <div key={id} className="type">
      <Button
        onClick={handleClick}
        variant="outlined"
        sx={{
          "&:hover": {
            borderColor: "#c09c72",
            backgroundColor: "#19130e",
          },
        }}
      >
        {name}
      </Button>
      {isAdmin && (
        <p
          style={{
            position: "absolute",
            right: -10,
            bottom: 20,
            backgroundColor: "#c09c72",
            color: "black",
            fontWeight: "bold",
            borderRadius: "50%",
            width: "24px",
            height: "24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {vendors.filter((vendor) => vendor.type?.id === id).length}
        </p>
      )}
    </div>
  );
}

export default VendorTypeComponent;
